<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="运营商:" :label-width="80">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">联系电话</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="充电站" :label-width="65">
				<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<!-- <FormItem prop="trackName" label="启动方式" :label-width="70">
				<Select placeholder="启动方式" style="width: 100px;" v-model="formInline.StartMode">
					<Option :value='-1'>全部</Option>
					<Option :value='0'>离线充电卡</Option>
					<Option :value='1'>在线充电卡</Option>
					<Option :value='2'>本地VIN码</Option>
					<Option :value='3'>在线VIN码</Option>
					<Option :value='4'>物理按键启动</Option>
					<Option :value='5'>屏幕启动</Option>
					<Option :value='6'>本地预约充电</Option>
					<Option :value='7'>平台预约充电</Option>
					<Option :value='48'>平台</Option>
				</Select>
			</FormItem> -->
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.OrderNo" style="width: 180px;" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" :options="options1" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<!-- <FormItem>
				<Input type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem> -->
			<FormItem>
				<Input type="text" v-model="formInline.EquipmentNo" style="width: 180px;" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.EquipmentSerialNo" style="width: 180px;" placeholder="设备序列号">
				<span slot="prepend">设备序列号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<!-- <Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder"
			size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getChargeRecordUrl" @listData='getDeviceData'>
			</MyPage>
		</Table> -->
		<PageTable ref="ChargingOrder" :columns="columns1" :tableHeight="tableHeight" :url="getChargeRecordUrl" :queryParam="pageParam"></PageTable>
		<echartModal ref="echartModal" curvesName="ChargeRecord"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import PageTable from '../../public/PageTable/PageTable.vue';
	// import Qs from 'qs'
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			echartModal,
			PageTable
		},
		data() {
			return {
				getChargeRecordUrl: webapi.base_api_url + '/Order/GetChargeRecord',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['充电记录', '>>', '充电记录'],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: '',
					EquipmentSerailNo: '',
					StartMode: -1
				},
				options1: {
						disabledDate (date) {
								return date && (date.valueOf() < Date.now() - (1000 * 60 * 60 * 24 * 30 * 3));
						}
				},
				//table标题数据
				columns1: [{
						title: '序号',
						type: 'index',
						width: 60
					}, {
						title: '开始时间',
						key: 'StartTime',
						width: 105
					},
					{
						title: '结束时间',
						key: 'EndTime',
						width: 105
					},
					{
						title: '订单单号',
						key: 'OrderNo',
						// fixed: 'left',
						width: 160
					},
					// {
					// 	title: '启动方式',
					// 	key: 'StartMode',
					// 	width: 100.,
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.StartModeDesc
					// 		);
					// 	}
					// },
					{
						title: '充电卡号',
						key: 'CardNo',
						width: 160
					},
					{
						title: '电量(度)',
						key: 'ChargeKwh',
						width: 80
					},
					// {
					// 	title: '充电电费(元)',
					// 	key: 'ElecCost',
					// 	width: 100
					// },
					// {
					// 	title: '充电服务费(元)',
					// 	key: 'ServiceCost',
					// 	width: 100
					// },
					// {
					// 	title: '费用(元)',
					// 	key: 'ChargeCost',
					// 	width: 80
					// },
					{
						title: '时长',
						key: 'ChargeDuration',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.ChargeDurationDesc);
						}
					},
					{
						title: 'SOC(%)',
						key: 'Soc',
						width: 90,
						render: (h, params) => h('div', { style: { textalign: 'center' } }, `${params.row.BeginSoc} -> ${params.row.EndSoc}`)
					},
					// {
					// 	title: '结束SOC(%)',
					// 	key: 'EndSoc',
					// 	width: 90
					// },
					// {
					// 	title: '充电前电表示值',
					// 	key: 'MeterBeginReading',
					// 	width: 120
					// },
					// {
					// 	title: '充电后电表示值',
					// 	key: 'MeterEndReading',
					// 	width: 120
					// },
					{
						title: '车辆VIN',
						key: 'CarVin',
						width: 110
					},
					{
						title: '停止原因',
						key: 'TerminateReason',
						width: 150
					},
					// {
					// 	title: '停止原因详情',
					// 	key: 'TerminateReasonDetail',
					// 	width: 150
					// },
					// {
					// 	title: '设备编号',
					// 	key: 'EquipmentNo',
					// 	width: 110
					// }, 
					{
						title: '枪编号',
						key: 'ConnectorNo',
						width: 110
					},
					{
						title: '设备序列号',
						key: 'EquipmentSerialNo',
						width: 110
					},
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 100,
					},
					// {
					// 	title: '操作',
					// 	key: 'action',
					// 	align: 'center',
					// 	width: 100,
					// 	render: (h, params) => {
					// 		return h('div', [
					// 			this.hasWidgets('chargeCurves') ? h('Button', {
					// 				props: {
					// 					type: 'primary',
					// 					size: 'small'
					// 				},
					// 				style: {
					// 					marginRight: '5px'
					// 				},
					// 				on: {
					// 					click: () => {
					// 						this.show("view", params.row.OrderNo)
					// 					}
					// 				}
					// 			}, '充电曲线') : h(),
					// 		]);
					// 	}
					// }
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			//this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				// const param = {
				// 	StationId: _this.formInline.StationId,
				// 	OrderNo: _this.formInline.OrderNo,
				// 	TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
				// 		.formInline.TimeBegin), 'yyyy-MM-dd'),
				// 	
				// 	MemberName: _this.formInline.MemberName,
				// 	EquipmentNo: _this.formInline.EquipmentNo
				// }
				let param = _this.formInline;
				param.TimeBegin = _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
					.formInline.TimeBegin), 'yyyy-MM-dd');
				param.TimeEnd = _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(new Date(_this.formInline
					.TimeEnd), 'yyyy-MM-dd');
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			})
		},
		watch: {},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				const _this = this;
				_this.$refs.ChargingOrder.exportCsv(tableData => {
					return {
						filename: '充电记录',
						columns: [..._this.columns1.filter((col) => col.type != 'index')],
						data: tableData.map(obj => {
							return {
								...obj,
								Soc: `${obj.BeginSoc} -> ${obj.EndSoc}`,
								OrderNo: '\t' + obj.OrderNo,
								CardNo: '\t' + obj.CardNo,
								ConnectorNo: '\t' + obj.ConnectorNo,
								EquipmentSerialNo: '\t' + obj.EquipmentSerialNo,
								StartTime: '\t' + (obj.StartTime || ''),
								EndTime: '\t' + (obj.EndTime || ''),
								ChargeDuration: '\t' + obj.ChargeDurationDesc,
							}
						}),
						// data: tableData.map(k => {
						// 	k.OrderNo = "\t" + k.OrderNo;
						// 	k.CardNo = "\t" + k.CardNo;
						// 	k.ConnectorNo = "\t" + k.ConnectorNo;
						// 	k.EquipmentSerialNo = "\t" + k.EquipmentSerialNo;
						// 	// k.OrderTime = '\t' + (k.OrderTime || '');
						// 	k.StartTime = '\t' + (k.StartTime || '');
						// 	k.EndTime = '\t' + (k.EndTime || '');
						// 	// k.RefundTime = '\t' + (k.RefundTime || '');
						// 	k.ChargeDuration = k.ChargeDurationDesc;
						// 	k.BeginSoc = `${k.BeginSoc} -> ${k.EndSoc}`
						// 	return k;
						// })
					};
				});
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			//操作
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			//Page组件回调
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.ChargingOrder.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1654 ? 40 : 0);
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>